import script from "./uploaddata.vue?vue&type=script&setup=true&lang=js"
export * from "./uploaddata.vue?vue&type=script&setup=true&lang=js"

import "./uploaddata.vue?vue&type=style&index=0&id=b2d31804&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2d31804"]])

export default __exports__